import { render, staticRenderFns } from "./DadoConteudo.vue?vue&type=template&id=610b61aa&scoped=true"
import script from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DadoConteudo.vue?vue&type=style&index=0&id=610b61aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610b61aa",
  null
  
)

export default component.exports